import defaultUrl from './dialog.html';

class DialogController {

    constructor($scope, $uibModalInstance, title, body) {
        'ngInject';

        $scope.body = body;
        $scope.title = title;

        $scope.ok = () => $uibModalInstance.close();

        $scope.cancel = ($event) => {
            $event.preventDefault();
            $event.stopPropagation();

            $uibModalInstance.dismiss('Action rejected.');
        };
    }
}

/**
 * @description
 * Provides basic modal dialog types like confirmation (yes - no) dialog etc.
 */
class DialogService {

    constructor($uibModal) {
        'ngInject';

        this.$uibModal = $uibModal;
    }

    /**
     * @description
     * Requires user to confirm his or her decision.
     *
     * @param {string} templateUrl Custom HTML Template.
     * @param {string} size Custom size.
     * @param {string} title Title to be used in template.
     * @param {string} body Body to be used in template.
     */
    confirm({templateUrl, size = 'sm', title, body, keyboard = true}) {
        templateUrl = templateUrl || defaultUrl.id;

        return this.$uibModal.open({
            keyboard,
            templateUrl,
            size,
            controller: DialogController,
            resolve: {
                title: () => title, body: () => body
            }
        }).result;
    }
}

angular
    .module('BB')
    .service('dialog', DialogService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/dialog/dialog.service.js